import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select';
import CreateClientServices from './../CreateClientServices';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from './../../../../shared/components/customExpandableTable';
import Loader from './../../../../shared/components/loader';
import Template1 from './../../../../shared/components/Template1';
import Matrix from './../../../../shared/components/matrix';
import MasterService from '../../../services/clientmanagement.service';
import ServiceView from './../../../../masterdata/views/contracttemplate/contracttemplateview/serviceview'
import CONSTANT from './../../../../shared/constants/constant'
import Util from './../../../../shared/util/util'
import Multiselect from 'vue-multiselect'
export default {
  name: 'ClientServicesListing',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    Matrix,
    CreateClientServices,
    Loader,
    Template1,
    CustomExpandableTable,
    ServiceView,
    Multiselect
  },
  data: function() {
    return {
      createContracts: false,
      isLoading: false,
      showServiceFlag: false,
      createTemplatesFlag: false,
      clientstatus: '',
      totalCount: 0,
      clientId: '',
      systemId: '',
      contractId: '',
      companyName: '',
      contractIdList: [],
      companyNamelist: [],
      selectedContractId: {
        "value": '',
        "text": ''
      },
      selectedcompanyName: {
        "value": '',
        "text": ''
      },
      tabIndex: 0,
      offset: 0,
      PrePaid: '',
      FTLServices: '',
      Surface: '',
      Air: '',
      Forward: '',
      Reverse: '',
      Credit: '',
      serviceType: '',
      Pay: '',
      serviceLevel: '',
      truckLoad: '',
      routemode: '',
      bookingType: '',
      servicearea: '',
      routemodeList: [],
      serviceLevelList: [],
      serviceTypelist: [],
      bookingTypelist: [],
      serviceArealist: [],
      selectedroutemode: {
        text: '',
        value: ''
      },
      selectedServiceLevel: {
        text: '',
        value: ''
      },
      selectedServiceType: {
        text: '',
        value: ''
      },
      selectedBookingType: {
        text: '',
        value: ''
      },
      selectedServiceArea: {
        text: '',
        value: ''
      },
      disabled: true,
      matrixHeaderArray: [{
          zoneid: 101,
          zonename: 'zone1'
        }, {
          zoneid: 102,
          zonename: 'zone2'
        },
        {
          zoneid: 103,
          zonename: 'zone3'
        }
      ],
      tableColumn: ['Client System ID','Client Business Account ID', 'Contract ID', 'Contract Name', 'Company Short/Display Name', 'Contracted Services','Created By','Created Date','Last Modified By','Last Modified Date','Contract Status','Action'],
      innerTableColumn: [],
      tableItems: [],
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      selectedContractServiceObj: '',
      serviceObj:{},
      showService :false
    }
  },
  computed: {},
  mounted() {
    this.getCompanyShortName();
    this.getContractIdList();
    this.getClientServicesList();
  },
  methods: {
    showCreateServices() {
      this.showServiceFlag = true;
    },
    // getCustomTableEvent(event) {
    //   if (event.actionType == "view") {
    //     this.createTemplatesFlag = true;
    //   }else if (event.actionType == "edit") {
    //     let selectedContractObj = this.tableArr.filter(function(Items) {
    //       return Items.id == event.id;
    //     });
    //     this.selectedContractObj = selectedContractObj[0];
    //     this.showServiceFlag = true;
    //   }
    // },
    callParent() {
      this.showServiceFlag = false;
      this.currentPage = 1;
      this.offset = 0;
      this.getClientServicesList();
    }, 
    createTemplates() {
      this.createTemplatesFlag = !this.createTemplatesFlag;
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getClientServicesList();
    },
    selectContractId(data) {
      this.selectedContractId = data;
      this.contractId = data.text;
    },
    selectCompanyName(data) {
      this.selectedcompanyName = data;
      this.companyName = data.CompanyName;
    },
    getUpdatedMatrixData(event) {
      console.log(event);
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    selectRouteMode() {},
    selectServiceType() {},
    selectBookingType() {},
    selectServiceArea() {},
    selectServiceLevel() {},
    searchServices() {
      this.currentPage = 1;
      this.offset = 0;
      this.getClientServicesList();
    },
    resetServices() {
      this.currentPage = 1;
      this.offset = 0;
      this.companyName = "";
      this.contractId = "";
      this.systemId = "";
      this.selectedContractId = {};
      this.selectedcompanyName = {};
      this.getClientServicesList();
    },
    async getClientServicesList() {
      this.isLoading = true;
      try {
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        if (this.companyName ) {
          inputPayload.companyname = this.companyName.text;
        }
        if (this.contractId ) {
          inputPayload.contractid = this.contractId.text;
        }
        if (this.systemId != '') {
          inputPayload.clientid = this.systemId;
        }

        let result = await MasterService.getClientServicesList(inputPayload);
        this.tableArr = result.data.data.rows;
        this.isLoading = false;
        this.totalCount = result.data.data.count.length;
   
        if (this.totalCount > 0) {
          this.tableArr = result.data.data.rows;
          this.tableItems = result.data.data.rows.map((el) => {
            let servicesData = [];
            if(el.ftlservices.length > 0){
              el.ftlservices.forEach(async function(item) {
                 servicesData.push("FTL - "+item.servicetype);
              });
            }
            if(el.ptlservices.length > 0){
              el.ptlservices.forEach(async function(item) {
                 servicesData.push("PTL - "+item.servicetype);
              });
            }
            return {
              'id': el.id,
              'Client System ID': el.clientid,
              'Client Business Account ID':el.clientbusinessaccountid,
              'Contract ID': el.contractidlabel,
              'Contract Name': el.contractname,
              'Company Short/Display Name': el.clientshortname,
              'Contracted Services': servicesData.join(", "),
              'Created By':el.createdby,
	            'Created Date':Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              'Contract Status': CONSTANT.CONTRACT_STATUS[el.contractstatus],
              'Action': el.contractstatus
            }
          })
        } else {
          this.tableItems = [];
        }
        if (this.totalCount < 10) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / 10);
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    getCustomTableEvent(event) {
      if (event.actionType == "active") {
        this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
          this.activeAction(event);
        }).catch((err) => {
          console.log(err)
        });
      } else if (event.actionType == "inactive") {
        this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
          this.activeAction(event);
        }).catch((err) => {
          console.log(err)
        })
      }
      if (event.actionType == "edit") {
        let selectedContractServiceObj = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedContractServiceObj = selectedContractServiceObj[0];
        this.showServiceFlag = true;
      } else if (event.actionType == "view") {
        // this.getClientContractDetailsById(event.id);
        let selectedViewRow = this.tableItems.filter(function(Items) {
          return Items.id == event.id;
        });
        this.showService = false;
        this.$nextTick(() => {
          this.serviceObj = {
            id: selectedViewRow[0].id,
            clientID: selectedViewRow[0]['Client System ID'],
            contractID: selectedViewRow[0]['Contract ID'],
            status: selectedViewRow[0].Status,
            view: selectedViewRow[0].view,
            ComponentName : CONSTANT.CLIENT_CONTRACT_TEMPLATE
          }
          this.showService = true;
        })
      }
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = []
        let result = await MasterService.getActiveInactiveClientList()
        CompanyShortList = this.getUniqueCompanyList(result.data.data);
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'value': CompanyShortList[i].ClientMasterID,
            'text': CompanyShortList[i].ClientShortName,
            'CompanyName': CompanyShortList[i].CompanyName
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    getUniqueCompanyList(array){
      let mymap = new Map();
      let unique = array.filter(el => {
          const val = mymap.get(el.ClientMasterID);
          if(val) {
              if(el.ClientShortName < val) {
                  mymap.delete(el.ClientMasterID);
                  mymap.set(el.ClientMasterID, el.ClientShortName, el.CompanyName);
                  return true;
              } else {
                  return false;
              }
          }
          mymap.set(el.ClientMasterID, el.ClientShortName, el.CompanyName);
          return true;
      });
      return unique;
    },
    async getContractIdList() {
      try {
        let inputPayload = {};
        let result = await MasterService.getClientContractDropdownList(inputPayload);
        let contractlist = result.data.data;
        for (var i = 0; i < contractlist.length; i++) {
          this.contractIdList.push({
            'value': contractlist[i].id,
            'text': contractlist[i].contractidlabel
          })
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientServices/ClientServicesListing/ServicesListing.component.js